import { useEffect, useRef, useState } from 'react'
import { GetNewGuid } from '../data/Help';

const InputFile = ({ id, label, files, onChange, isRequired = true, maxFiles = 999 }: IInputFile) => {

    const [lblFileCount, setLblFileCount] = useState('Ningún archivo seleccionado');
    const [isValid, setIsvalid] = useState(false);
    let inputRef = useRef<HTMLInputElement>(null);
    let inpuReqtRef = useRef<HTMLInputElement>(null);
    let btnRef = useRef<HTMLButtonElement>(null);

    const handlerClick = () => inputRef.current?.click();
    const handlerChange = (obj: any) => processFile(obj.target.files, true);
    const getTxtFileCount = (count: number) => {
        switch (count) {
            case 0: return 'Ningún archivo seleccionado';
            case 1: return 'Un archivo adjunto';
            default: return `${count}  archivos adjuntos`;
        }
    }

    const processFile = (lstFile: Array<File>, isMod: boolean) => {
        setLblFileCount(getTxtFileCount(lstFile.length));
        onChange(id, lstFile, isMod)
    }

    useEffect(() => {
        if (isRequired) {
            inpuReqtRef.current?.setCustomValidity("");
            setIsvalid(true);
            if (files === undefined) {
                setIsvalid(false);
                inpuReqtRef.current?.setCustomValidity("Adjunte una imagen");
            }
            if (files?.length === 0) {
                setIsvalid(false);
                inpuReqtRef.current?.setCustomValidity("Adjunte una imagen");
            }
            if ((files?.length ?? 0) > maxFiles) {
                setIsvalid(false);
                inpuReqtRef.current?.setCustomValidity(`Solo se permite adjuntar un máximo ${maxFiles} archivos`);
            }
        }
    },)

    useEffect(() => {
        processFile(files ?? [], false);
    },[])

    return (
        <>
            <div className='lbl-input-auto-cr-emi mt-10 mb-5'>{label} {isRequired && label.length > 0 && <span style={{ color: '#FF5F49' }}>*</span>}</div>
            <div className='input-file-group-re-ni'>
                <button type="button" className="lbl-input-file-re-ni" ref={btnRef} onClick={handlerClick}>
                    Seleccionar archivo
                </button>
                <label className='lbl-input-file-re-ni'>{lblFileCount}</label>
                {isRequired && !isValid && (
                    <input ref={inpuReqtRef} type="radio" name={GetNewGuid()} className="sg-switch-validator mt-10" />
                )}
                <input
                    id={id}
                    multiple
                    accept=".png, .jpg, .jpeg"
                    type="file"
                    ref={inputRef}
                    style={{ height: '0px', width: '0px', overflow: 'hidden', opacity: 0 }}
                    onChange={handlerChange}
                />
            </div>
        </>
    );
}

export { InputFile }